<template>
  <span>
    <img v-if="isCountrySupported" :src="flagImage" alt="" />
    {{ countryName }}
  </span>
</template>

<script>
import flagAT from '@/assets/flags/flag_at.svg'
import flagBE from '@/assets/flags/flag_be.svg'
import flagCH from '@/assets/flags/flag_ch.svg'
import flagCZ from '@/assets/flags/flag_cz.svg'
import flagDE from '@/assets/flags/flag_de.svg'
import flagDK from '@/assets/flags/flag_dk.svg'
import flagFR from '@/assets/flags/flag_fr.svg'
import flagHR from '@/assets/flags/flag_hr.svg'
import flagHU from '@/assets/flags/flag_hu.svg'
import flagIT from '@/assets/flags/flag_it.svg'
import flagLU from '@/assets/flags/flag_lu.svg'
import flagMA from '@/assets/flags/flag_ma.svg'
import flagNL from '@/assets/flags/flag_nl.svg'
import flagPL from '@/assets/flags/flag_pl.svg'
import flagRM from '@/assets/flags/flag_rm.svg'
import flagRS from '@/assets/flags/flag_rs.svg'
import flagSE from '@/assets/flags/flag_se.svg'
import flagSI from '@/assets/flags/flag_si.svg'
import flagSK from '@/assets/flags/flag_sk.svg'
// TODO add BG ES NO flags

export default {
  props: ['code'],
  computed: {
    countryCode() {
      return this.mapping[this.code];
    },
    flagImage() {
      return this.imgPaths[this.countryCode]
    },
    countryName() {
      if (this.isCountrySupported(this.countryCode)) {
        return this.$i18n.t(`country.${this.countryCode}`);
      }
      return this.name;
    }
  },
  data() {
    return {
      mapping: {
        A: 'AT',
        B: 'BE',
        BG: 'BG',
        CH: 'CH',
        CZ: 'CZ',
        D: 'DE',
        DK: 'DK',
        ES: 'ES',
        F: 'FR',
        H: 'HU',
        HR: 'HR',
        I: 'IT',
        LUX: 'LU',
        M: 'MA',
        N: 'NO',
        NL: 'NL',
        PL: 'PL',
        RO: 'RM',
        S: 'SE',
        SK: 'SK',
        SLO: 'SI',
        SRB: 'RS',
      },
      imgPaths: {
        AT: flagAT,
        BE: flagBE,
        CH: flagCH,
        CZ: flagCZ,
        DE: flagDE,
        DK: flagDK,
        FR: flagFR,
        HR: flagHR,
        HU: flagHU,
        IT: flagIT,
        LU: flagLU,
        MA: flagMA,
        NL: flagNL,
        PL: flagPL,
        RM: flagRM,
        RS: flagRS,
        SE: flagSE,
        SI: flagSI,
        SK: flagSK
      }
    }
  },
  methods: {
    isCountrySupported() {
      return this.countryCode in this.imgPaths
    }
  }
}
</script>